module.exports = __webpack_public_path__ + "media/images/webpage/hotels/1319/plan2-1-00fa21186e63ab036047670d3ac0fac1.webp";